import React from 'react';
import { Popup, Checkbox, Icon, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

import { Table, MessagingIcon } from 'dyl-components';
import { TextMessageModal, EmailModal, NotesModal } from 'shared/modals';
import { TwoLinedContent } from 'dyl-components';
import LatestNoteContent from 'shared/LatestNoteContent';

const ExportTableRow = ({ lead, onMark, onCall, onToggleModal, onShowNote, noteVisible, onUserUpdate, users, isUpdatingLead }) => (
    <Table.Row active={lead.isMarked}>
        <Table.Cell>
            <Checkbox checked={lead.isMarked} onChange={onMark} />
        </Table.Cell>
        <Table.Cell>
            <TwoLinedContent firstLine={lead.received.split('T')[0]}
                secondLine={lead.received.split('T')[1]} />
        </Table.Cell>
        <Table.Cell>
            <TwoLinedContent firstLine={lead.source}
                secondLine={lead.type} />
        </Table.Cell>
        <Table.Cell>
            <Link to={`/lead?id=${lead.id}`}>
                <Icon name='circle' className={`Contact__status-icon`} />
                <TwoLinedContent className={'Contact__details'} firstLine={`${lead.first_name} ${lead.last_name}`}
                    secondLine={lead.phone} />
            </Link>
        </Table.Cell>
        <Table.Cell>
            <Dropdown
                options={[
                    { key: 'unassigned', value: 'unassigned', text: 'Unassigned' },

                ]}
                value={lead.assigned && lead.assigned.id ? lead.assigned.id : 'unassigned'}
                onChange={(_, { value }) => { }}
                loading={isUpdatingLead}
                disabled={isUpdatingLead}
            />
        </Table.Cell>
        <Table.Cell>
            {lead.latest_note && (
                <LatestNoteContent
                    noteVisible={noteVisible}
                    latestNote={lead.latest_note}
                    onShowNote={onShowNote}
                />
            )}
        </Table.Cell>
        <Table.Cell>
            <Popup inverted position='top center' trigger={<span className='LeadsTable__messagingIcon'><MessagingIcon size='' icon={'phone'} onClick={() => { onCall(lead) }} /></span>} content='Call' />
            <Popup inverted position='top center' trigger={<span className='LeadsTable__messagingIcon'><MessagingIcon size='' icon={'conversation'} onClick={() => { onToggleModal('text') }} /></span>} content='Text' />
            <Popup inverted position='top center' trigger={<span className='LeadsTable__messagingIcon'><MessagingIcon size='' icon={'mail'} onClick={() => { onToggleModal('email') }} /></span>} content='Email' />
            <Popup inverted position='top center' trigger={<span className='LeadsTable__messagingIcon'><MessagingIcon size='' icon={'list alternate outline'} onClick={() => { onToggleModal('add_note') }} /></span>} content='View Notes' />
        </Table.Cell>
    </Table.Row>
)

class ExportTableRowContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeModal: null,
            actionBarVisible: false,
            noteVisible: false
        }
        this.onToggleModal = this.onToggleModal.bind(this);
        this.onShowNote = this.onShowNote.bind(this);
    }

    onToggleModal(name) {
        this.setState({
            activeModal: name
        })
    }

    isOpenModal(name) {
        return this.state.activeModal === name;
    }

    onShowNote() {
        this.setState({
            noteVisible: !this.state.noteVisible
        })
    }

    render() {
        const { lead } = this.props;
        return (
            <React.Fragment>
                <ExportTableRow
                    lead={lead}
                    onToggleModal={this.onToggleModal}
                    noteVisible={this.state.noteVisible}
                    onShowNote={this.onShowNote}
                    {...this.props}
                />
                <TextMessageModal
                    open={this.isOpenModal('text')}
                    onClose={this.onToggleModal}
                    lead={lead}
                />
                <EmailModal
                    open={this.isOpenModal('email')}
                    onClose={this.onToggleModal}
                    lead={lead}
                />
                {this.isOpenModal('add_note') && (
                    <NotesModal
                        open={this.isOpenModal('add_note')}
                        onClose={this.onToggleModal}
                        lead={lead}
                    />)
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = (state, { lead }) => {

}

const mapDispatchToProps = (dispatch, { lead }) => ({

})

export default connect(mapStateToProps, mapDispatchToProps)(ExportTableRowContainer);
